module.exports = __webpack_public_path__ + "media/02_Witch_of_Creation.3207a84a.mp3";